import { AlertContext } from "@laborchart-modules/common/dist/postgres/schemas/common/enums";
import { getDetachedDay } from "@laborchart-modules/common/dist/datetime";
import type { UpdateAlertResponse } from "@laborchart-modules/lc-core-api/dist/api/alerts/update-alert";
import { AlertStore } from "@/stores/alert-store.core";
import { stripAndReturnHTMLTokens } from "@/react/components/communications/dynamic-tokens/token-utils";
import { computeScheduledTime } from "@/react/components/communications/communications-helpers";
import type { EditAlertFormValues } from "@/react/components/communications/communications-prop-types";

/**
 * Updates an existing scheduled or draft alert via PATCH /api/v3/alerts/:id.
 * Only scheduled alerts carry scheduled_day + scheduled_time; the client sends them and the server
 * computes send_at in the alert's stored timezone.
 */
export async function updateScheduledOrDraftAlert(
   alertId: string,
   projectId: string,
   values: EditAlertFormValues,
   context: AlertContext,
): Promise<UpdateAlertResponse> {
   const shouldSchedule = context === AlertContext.SCHEDULED;
   const { content } = stripAndReturnHTMLTokens(values.content, projectId);
   const { content: subject } = stripAndReturnHTMLTokens(values.subject, projectId);

   return await AlertStore.updateAlert({
      params: { alert_id: alertId },
      body: {
         content,
         subject,
         context,
         recipient_ids: values.recipients.map((recipient) => recipient.id),
         scheduled_day: shouldSchedule ? getDetachedDay(values.scheduled_day) : undefined,
         scheduled_time: shouldSchedule ? computeScheduledTime(values) : undefined,
      },
   }).payload;
}
